import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePointingBlackjack } from "./PointingBlackjackProvider";
import { sessionPath } from "./paths";
import { LOBBY_START_BUTTONS, SessionEntryForm } from "./SessionEntryForm";

export const PointingBlackjackLobby: React.FC = () => {
  const { createSession, state, lastError, connectionStatus } =
    usePointingBlackjack();
  const navigate = useNavigate();

  useEffect(() => {
    if (state?.sessionId && !state.gameOver) {
      navigate(sessionPath(state.sessionId), { replace: true });
    }
  }, [state, navigate]);

  const busy = connectionStatus === "connecting";

  return (
    <div className="pb-lobby">
      <section className="pb-panel">
        <h2>Start a session</h2>
        <p className="pb-muted">You’ll get a link to share with your team.</p>
        <SessionEntryForm
          busy={busy}
          buttons={LOBBY_START_BUTTONS}
          onSubmit={({ role, name }) => {
            createSession(name, { role });
          }}
        />
      </section>

      {lastError ? <p className="pb-error">{lastError}</p> : null}
    </div>
  );
};
